import { render, staticRenderFns } from "./DeviceTraitedDataByDeviceMetricDatatableWidgetComponent.vue?vue&type=template&id=ba05a0a8&"
import script from "./DeviceTraitedDataByDeviceMetricDatatableWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./DeviceTraitedDataByDeviceMetricDatatableWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports